import { render } from "./PersonalHelp.vue?vue&type=template&id=158178c0&ts=true"
import script from "./PersonalHelp.ts?vue&type=script&lang=ts&external"
export * from "./PersonalHelp.ts?vue&type=script&lang=ts&external"

import "./PersonalHelp.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__